"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// import SearchAutocomplete from '../modules/search-autocomplete'
var Main = /*#__PURE__*/function () {
  function Main() {
    _classCallCheck(this, Main);

    this.selectors = {};
    this.init();
    this.events();
  }

  _createClass(Main, [{
    key: "init",
    value: function init() {
      this.getNodes();
    }
  }, {
    key: "getNodes",
    value: function getNodes() {
      var _this = this;

      this.nodes = {};
      $.each(this.selectors, function (key, selector) {
        _this.nodes[key] = $(selector);
      });
    }
  }, {
    key: "events",
    value: function events() {
      $(document).ready(function () {
        $('.header__middle__cart').remove();
      });
    }
  }]);

  return Main;
}();

new Main();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1haW4uZW50cnkuanMiXSwibmFtZXMiOlsiTWFpbiIsInNlbGVjdG9ycyIsImluaXQiLCJldmVudHMiLCJnZXROb2RlcyIsIl90aGlzIiwibm9kZXMiLCIkIiwiZWFjaCIsImtleSIsInNlbGVjdG9yIiwiZG9jdW1lbnQiLCJyZWFkeSIsInJlbW92ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTtJQUVNQSxJO0FBRUYsa0JBQWE7QUFBQTs7QUFDVCxTQUFLQyxTQUFMLEdBQWlCLEVBQWpCO0FBR0EsU0FBS0MsSUFBTDtBQUNBLFNBQUtDLE1BQUw7QUFDSDs7OztXQUVELGdCQUFNO0FBQ0YsV0FBS0MsUUFBTDtBQUNIOzs7V0FFRCxvQkFBVztBQUNQLFVBQUlDLEtBQUssR0FBRyxJQUFaOztBQUNBLFdBQUtDLEtBQUwsR0FBYSxFQUFiO0FBQ0FDLE1BQUFBLENBQUMsQ0FBQ0MsSUFBRixDQUFPLEtBQUtQLFNBQVosRUFBdUIsVUFBU1EsR0FBVCxFQUFjQyxRQUFkLEVBQXdCO0FBQzNDTCxRQUFBQSxLQUFLLENBQUNDLEtBQU4sQ0FBWUcsR0FBWixJQUFtQkYsQ0FBQyxDQUFDRyxRQUFELENBQXBCO0FBQ0gsT0FGRDtBQUdIOzs7V0FFRCxrQkFBUTtBQUNKSCxNQUFBQSxDQUFDLENBQUNJLFFBQUQsQ0FBRCxDQUFZQyxLQUFaLENBQWtCLFlBQU07QUFDcEJMLFFBQUFBLENBQUMsQ0FBQyx1QkFBRCxDQUFELENBQTJCTSxNQUEzQjtBQUNILE9BRkQ7QUFHSDs7Ozs7O0FBSUwsSUFBSWIsSUFBSiIsInNvdXJjZXNDb250ZW50IjpbIi8vIGltcG9ydCBTZWFyY2hBdXRvY29tcGxldGUgZnJvbSAnLi4vbW9kdWxlcy9zZWFyY2gtYXV0b2NvbXBsZXRlJ1xuXG5jbGFzcyBNYWluIHtcblxuICAgIGNvbnN0cnVjdG9yKCl7XG4gICAgICAgIHRoaXMuc2VsZWN0b3JzID0geyAgICAgICAgXG5cbiAgICAgICAgfTtcbiAgICAgICAgdGhpcy5pbml0KCk7XG4gICAgICAgIHRoaXMuZXZlbnRzKCk7XG4gICAgfVxuXG4gICAgaW5pdCgpeyAgICAgICAgXG4gICAgICAgIHRoaXMuZ2V0Tm9kZXMoKTtcbiAgICB9XG5cbiAgICBnZXROb2RlcygpIHtcbiAgICAgICAgdmFyIF90aGlzID0gdGhpcztcbiAgICAgICAgdGhpcy5ub2RlcyA9IHt9O1xuICAgICAgICAkLmVhY2godGhpcy5zZWxlY3RvcnMsIGZ1bmN0aW9uKGtleSwgc2VsZWN0b3IpIHtcbiAgICAgICAgICAgIF90aGlzLm5vZGVzW2tleV0gPSAkKHNlbGVjdG9yKTtcbiAgICAgICAgfSk7XG4gICAgfVxuXG4gICAgZXZlbnRzKCl7XG4gICAgICAgICQoZG9jdW1lbnQpLnJlYWR5KCgpID0+IHsgICAgICAgICAgIFxuICAgICAgICAgICAgJCgnLmhlYWRlcl9fbWlkZGxlX19jYXJ0JykucmVtb3ZlKCk7XG4gICAgICAgIH0pO1xuICAgIH1cblxufVxuXG5uZXcgTWFpbigpO1xuIl19